<template>
  <div class="content" v-statusBarHeight="'paddingTop'">
    <div :class="['title', env.isBankabc ? 'title-bankabc' : '']" id="historyTitle" tabindex="0">
      <span>浏览记录</span>
    </div>
    <div v-if="isGet" class="list">
      <template v-if="list && list.length">
        <swiper class="data" :options="swiperOption">
          <swiper-slide v-for="(item, index) in list" :key="'history_item_' + index" class="item">
            <div
              @click="goToDetail(item.spuId)"
              v-track="trackData.history({ spu_id: item.spuId, sku_id: skuId, position: index + 1 })"
              tabindex="0"
            >
              <div class="img">
                <img :src="item.pic" alt="" />
              </div>
              <div v-if="item.name" class="name txt">{{ item.name }}</div>
              <div v-if="item.brief" class="des txt">{{ item.brief }}</div>
              <div class="price">
                <template v-if="item.salePrice <= 0">
                  <span class="no-sale">暂无报价</span>
                </template>
                <template v-else>
                  <span class="sale">
                    <i>￥</i>
                    {{ item.salePrice === 999999 ? '待发布' : item.salePrice }}
                  </span>
                  <span
                    v-if="item.salePrice < item.marketPrice"
                    class="market"
                    :aria-label="`原价￥${item.marketPrice}`"
                  >
                    {{ '￥' + item.marketPrice }}
                  </span>
                </template>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide :class="['no-more', env.isIOS ? 'no-more-ios' : '']">
            <span>没有更多了~</span>
          </swiper-slide>
        </swiper>
      </template>
      <div v-else class="no-data">
        <!-- 无数据 -->
        <div class="icon"></div>
        <div class="des">无浏览记录</div>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/utils'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// 环境
import env from '@/utils/clientEnv'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'
import { getPosterInfo } from './api'
// 埋点数据
import trackData from '../../trackData'
export default {
  name: 'History',
  components: {
    swiper: VueAwesomeSwiper.swiper,
    swiperSlide: VueAwesomeSwiper.swiperSlide
  },
  data() {
    return {
      list: null,
      env,
      // 是否获取了数据
      isGet: false,
      trackData
    }
  },
  computed: {
    ...mapGetters('detailv3', ['skuId']),
    swiperOption() {
      return {
        direction: 'vertical',
        slidesPerView: 'auto'
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.isGet = false
      // 此处的处理，主要是为了去掉当前浏览的商品
      const HIST = 'shop_view_history'
      const historyCookie = Cookies.get(HIST)
      try {
        let hisAry = historyCookie.split('-')
        let tempCookie = hisAry.slice(0, hisAry.length - 1).join('-')
        Cookies.set(HIST, tempCookie, { domain: document.domain, expires: 365 * 10, path: '/' })
      } catch (e) {}
      const data = await getPosterInfo().catch(e => {
        Cookies.set(HIST, historyCookie, { domain: document.domain, expires: 365 * 10, path: '/' })
      })
      if (data) {
        this.list = data
        Cookies.set(HIST, historyCookie, { domain: document.domain, expires: 365 * 10, path: '/' })
      }
      this.isGet = true
    },
    goToDetail(spuId) {
      if (spuId) {
        app.openNewWebview({
          url: 'https://shop.vivo.com.cn/wap/product/' + spuId
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-1,
.vivo-fontscale-2 {
  .list .data .item {
    height: 472px;
  }
}
.vivo-fontscale-5 {
  .list .data .item {
    height: 522px;
    .txt {
      height: 48px;
    }
  }
}
</style>
